/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobileDevice
 */
export interface MobileDevice {
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MobileDevice
     */
    deviceId: string;
    /**
     * 
     * @type {number}
     * @memberof MobileDevice
     */
    client?: number;
    /**
     * 
     * @type {Date}
     * @memberof MobileDevice
     */
    createdAt: Date;
}

export function MobileDeviceFromJSON(json: any): MobileDevice {
    return MobileDeviceFromJSONTyped(json, false);
}

export function MobileDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileDevice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceId': json['device_id'],
        'client': !exists(json, 'client') ? undefined : json['client'],
        'createdAt': (new Date(json['created_at'])),
    };
}

export function MobileDeviceToJSON(value?: MobileDevice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'device_id': value.deviceId,
        'client': value.client,
        'created_at': (value.createdAt.toISOString()),
    };
}


